angular.module('callX').controller('EditAccountCtrl', ['$scope', 'UserService', 'toaster', 'DataService', '$state', function($scope, UserService, toaster, DataService, $state) {

    $scope.editAccount = {};
    $scope.countries = DataService.getCountries();
    $scope.country = {};
    $scope.states = DataService.getProvince();
    $scope.state = {};
    
    var formStateFilteredList = function () {
        $scope.stateFilteredList = [];
        if (!$scope.country.selected) return;
        var selectedCode = $scope.country.selected.code;
        for( var i = 0; i < $scope.states.length; i++ ) {
            if($scope.states[i].code.indexOf(selectedCode) == 0) {
                $scope.stateFilteredList.push($scope.states[i]);
            }
        }
    };

    var setStateAndCountryFromData = function () {
        $scope.editAccount = angular.copy($scope.currentUserData);
        $scope.country.selected = $scope.editAccount.company_country;
        $scope.state.selected = $scope.editAccount.company_state;
    };

    $scope.$on('currentUserUpdate', function(event, currentUserData) {
        $scope.currentUserData = currentUserData;
        setStateAndCountryFromData();
        formStateFilteredList();
    });
    $scope.currentUserData = UserService.getCurrentUserData();
    setStateAndCountryFromData();
    formStateFilteredList();

    $scope.$watch(
        "country.selected",
        function handleFooChange( newValue, oldValue ) {
            if(oldValue!=undefined){
                formStateFilteredList();
            }
        }
    );

    $scope.updateAccount = function () {
        if ($scope.editAccount.first_name == undefined) {
            toaster.pop('error', 'First Name',  'First Name is required.', 2000);
        }
        else if ($scope.editAccount.last_name == undefined) {
            toaster.pop('error', 'Last Name', 'Last Name is required', 2000);
        }
        // else if ($scope.editAccount.title == undefined) {
        //     toaster.pop('error', 'Title', 'Title is required', 2000);
        // }
        else if ($scope.editAccount.email == undefined) {
            toaster.pop('error', 'Email', 'Email is required', 2000);
        }
        else if ($scope.editAccount.company_name == undefined) {
            toaster.pop('error', 'Company Name', 'Company Name is required', 2000);
        }
        else if ($scope.editAccount.company_website == undefined) {
            toaster.pop('error', 'Company Website', 'Company Website is required', 2000);
        }
        else if ($scope.editAccount.company_address1 == undefined) {
            toaster.pop('error', 'Address Line 1', 'Address Line 1 is required', 2000);
        }
        else if ($scope.editAccount.company_city == undefined) {
            toaster.pop('error', 'Company City', 'Company City is required', 2000);
        }
        else if ($scope.editAccount.company_phone_number == undefined) {
            toaster.pop('error', 'Company Phone Number', 'Company Phone Number is required', 2000);
        }
        else if ($scope.editAccount.company_postal_code == undefined) {
            toaster.pop('error', 'Company Postal Code', 'Company Postal Code is required', 2000);
        }
        else if ($scope.country.selected == undefined) {
            toaster.pop('error', 'Country', 'Country is required', 2000);
        }
        else if ($scope.state.selected == undefined) {
            toaster.pop('error', 'State', 'State is required', 2000);
        }

        else{
            $scope.editAccount.company_country = $scope.country.selected;
            $scope.editAccount.company_state = $scope.state.selected;
//            console.log("$scope.editAccount",$scope.editAccount);
            var callbacks = {
                success: function (data) {
                    toaster.pop('success', 'Success', 'Account successfully updated', 2000);
                    $state.go('app.account.view');
                },
                failure: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.updateUserAccount($scope.editAccount.id, $scope.editAccount, callbacks);
        }
    };

}]);